import axios from "axios";
import formats from "../utils/formats";
import coursesClient from "./courses";

const MANIFEST_ENDPOINT = "https://mycia-mcm.s3.eu-central-1.amazonaws.com/:token/:lang/manifest.json";
const COURSES_ENDPOINT = "https://mycia-mcm.s3.eu-central-1.amazonaws.com/:token/:lang/:consumetime/:filename";

const cache = new Map();

async function fetchCoursesData(lang, restaurantToken) {
    const cacheKey = `${restaurantToken}-${lang}`;

    if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
    }

    let manifest;
    try {
        const manifestUrl = formats.formatUrl(MANIFEST_ENDPOINT, { token: restaurantToken, lang });
        const manifestUrlWithoutCache = `${manifestUrl}?t=${Date.now()}`;
        const manifestResp = await axios.get(manifestUrlWithoutCache);
        manifest = manifestResp.data;
    } catch (err) {
        throw err;
    }

    const coursesFile = manifest?.courses;
    if (!coursesFile) {
        throw new Error("Courses key not found in manifest.");
    }

    const consumetime = formats.getConsumeTime(restaurantToken);
    const coursesUrl = formats.formatUrl(COURSES_ENDPOINT, {
        lang,
        token: restaurantToken,
        consumetime,
        filename: coursesFile
    });

    try {
        const response = await axios.get(coursesUrl);
        const coursesData = response.data;

        if (!coursesData?.data || !Array.isArray(coursesData.data) || coursesData.data.length === 0) {
            throw new Error("Courses data is empty or invalid.");
        }

        cache.set(cacheKey, coursesData);

        return coursesData;
    } catch (error) {
        throw new Error("Courses error: " + error.message);
    }
}

async function doGet(lang, restaurantToken, id) {
    try {
        const courses = await fetchCoursesData(lang, restaurantToken);
        const course = courses.data.find(
            (course) => course.id.toString() === id.toString()
        );

        if (course) {
            return course;
        }
    } catch (error) {
        // Fallback to legacy coursesClient
        return await coursesClient.doGet(lang, id);
    }
}

const coursesClientV2 = {
    doGet,
};

export default coursesClientV2;
